import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./WidgetsFloatingMenu.css";
import { GetAllWidgets } from "../../../../redux/action/Widgets/widgetActions";
import { useDispatch, useSelector } from "react-redux";
const WidgetsFloatingMenu = () => {
  const [active, setActive] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    GetAllWidgets(dispatch);
  }, []);

  var widgets = [];
  widgets = useSelector(
    (state) => state?.widgetsReducer?.getAllTypeWidget?.getAllTypeWidget
  );

  const show = widgets?.some((ele) => ele.is_active);

  return (
    <>
      {show ? (
        <div
          className={
            active
              ? "floatingMenuContainerActive"
              : "floatingMenuContainerinActive"
          }
        >
          {widgets?.map((ele, i) =>
            ele.is_active ? (
              <div
                key={i}
                className={active ? "widgetItemActive" : "widgetItemInactive"}
              >
                <Link to={ele.frontOffice + ele.id}>
                  {" "}
                  <img src={ele.icon} />
                </Link>
                {active ? <p className="ItemTitle">{ele.name}</p> : ""}
              </div>
            ) : (
              ""
            )
          )}

          {!active ? (
            <img
              className="menuStatus"
              onClick={() => setActive(!active)}
              src="https://res.cloudinary.com/jobify/image/upload/v1666197281/Viewmore_bkbit2.png"
            />
          ) : (
            <img
              className="menuStatus"
              onClick={() => setActive(!active)}
              src="https://res.cloudinary.com/jobify/image/upload/v1666197281/Viewless_ewypr3.png"
            />
          )}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default WidgetsFloatingMenu;
